<script setup lang="ts">
import { inject, onMounted, reactive, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import MarketCartInfos from './../../components/MarketCartInfos.vue';
import MarketCheckoutModeLivraisonForm from './MarketCheckoutModeLivraisonForm.vue';
import { useMarketCartStore } from '@/stores/cart.store';
import { storeToRefs } from 'pinia';
import MarketCheckoutAdressesListModal from '../../modals/MarketCheckoutAdressesListModal.vue';
import axios from 'axios';
import { showAlert } from '@/utils/swal';

const BACKEND_URL = inject('BACKEND_URL');
const router = useRouter();
const layout = ref('none');
const cart = useMarketCartStore();
const { items } = storeToRefs(cart);
const loading = ref(false);
const errorMessage = ref('');
const isCheckoutFormValid = ref(false);
const checkoutForm = reactive({
    mode_livraison: -1,
    adresse: null as any | null,
});
const checkoutFormErrors = reactive({
    mode_livraison: "",
    adresse: "",
});
const startupInfos = reactive({
    adresses: [] as any[],
});
const adressesListModalRef = ref<InstanceType<typeof MarketCheckoutAdressesListModal> | null>(null);

onMounted(() => {
    layout.value = router.currentRoute.value.meta.layout as string || 'none';
    Object.assign(startupInfos, router.currentRoute.value.meta.startup_infos);
    if (startupInfos.adresses.length > 0) {
        const defaultAdresse = startupInfos.adresses.find(a => a.is_default);
        if (defaultAdresse) {
            checkoutForm.adresse = defaultAdresse;
        } else {
            checkoutForm.adresse = startupInfos.adresses[0];
        }
    }
});

watch(checkoutForm, (oldFormData, newFormData) => {
    validateCheckoutFOrm();
});

function validateCheckoutFOrm() {
    let isValid = true;

    checkoutFormErrors.mode_livraison = "";
    if (!checkoutForm.mode_livraison) {
        checkoutFormErrors.mode_livraison = "Veuillez sélectionner un mode de livraison";
        isValid = false;
    }

    if (checkoutForm.mode_livraison !== -1) {
        checkoutFormErrors.adresse = "";
        if (!checkoutForm.adresse) {
            checkoutFormErrors.adresse = "Veuillez sélectionner une adresse de livraison";
            isValid = false;
        }
    }

    isCheckoutFormValid.value = isValid;

    return isValid;
}

function onModeLivraisonSelected(mode_livraison_id: number) {
    checkoutForm.mode_livraison = mode_livraison_id;
}

async function openAdressesListModal() {
    const selectedAdresse = await adressesListModalRef.value?.open(startupInfos.adresses);
    if (selectedAdresse) {
        checkoutForm.adresse = selectedAdresse;
    }
}

async function onSubmitModeLivraisonForm() {
    if (!validateCheckoutFOrm()) {
        return;
    }
    loading.value = true;
    try {
        await axios.post(`/market/create_commande`, {
            type_livraison_id: checkoutForm.mode_livraison,
            adresse_livraison_id: checkoutForm.adresse?.id,
            items: cart.items.map(item => ({
                produit_id: item.id,
                quantite: item.quantite,
                prix_unitaire: item.montant,
            })),
            subtotal: cart.getSubTotal,
            total: cart.getTotal,
        });
        router.push('/front/market/commandes');
    } catch (error: any) {
        errorMessage.value = error.message || 'Une erreur est survenue lors de la validation de votre commande. Veuillez réessayer.';
        await showAlert.error(errorMessage.value);
        loading.value = false;
    }
}

</script>
<template>
    <div class="page-space-50" v-if="layout == 'none'"></div>
    <section class="container-lil">

        <div class="s10_mobile">

            <div class="widget px-6 pt-5">
                <h2 class="secondary-font mb-4">Ma commande</h2>
                
                <div class="grid-web4">
                    <div v-for="(item, index) of items" :key="index">
                        <div class="img-area rounded-20 mx-1 mb-3 px-3 py-2" style="height: 70px; overflow: hidden; display: flex; justify-content: center; align-items: center;">
                            <img :src="BACKEND_URL + '/assets/market_produits/300/' + item.image" style="max-width: 100%; max-height: 60px;" />
                        </div>
                        <h5 class="price secondary-font mb-3 text-center">x{{ item.quantite }}</h5>
                    </div>
                </div>
            </div>
            
            <div class="clear-both h-25"></div>
            
            <market-checkout-mode-livraison-form @update:modelValue="onModeLivraisonSelected" @onEditAdresse="openAdressesListModal" :startupInfos="startupInfos" :adresse="checkoutForm.adresse" ></market-checkout-mode-livraison-form>

            <button class="btn-ultra lg w-100 flex-center" :class="{'loading': loading}" :disabled="!isCheckoutFormValid || loading" @click="onSubmitModeLivraisonForm">
                <div class="btn-show">
                    <span>Valider</span>
                </div>
                <div class="btn-loading">
                    <div class="loader-dots"></div>
                </div>
            </button>
            <div class="clear-both h-20"></div>

        </div>

        <div class="s1_mobile">&nbsp;</div>

        <div class="s9_mobile">
            <market-cart-infos :layout="layout" :hide-button="true"></market-cart-infos>
        </div>
    </section>

    <div class="clear-both h-60"></div>
     <market-checkout-adresses-list-modal ref="adressesListModalRef"></market-checkout-adresses-list-modal>
</template>